import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, CHECKOUT_URL, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="scroll-mt-2 border-y-4 border-gold bg-forge" data-id="element-118" data-mp="ddvgdgeskhf3">
      <div className="mx-auto max-w-xl px-3 py-5 text-center sm:px-5" data-id="element-119" data-mp="icghdi1vb54l">
        <p className="text-xs font-bold uppercase tracking-widest text-ink" data-id="element-120" data-mp="meabf7hk5avs">
          Oferta especial — Sistema completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-anton text-2xl uppercase leading-tight text-white sm:text-3xl" data-id="element-121" data-mp="reg1ij86ipbr">
          Comenzá hoy desde cero y avanzá a tu ritmo.
        </h2>

        <Reveal className="mt-3 overflow-hidden rounded-xl border-4 border-dashed border-ink bg-white text-ink" data-id="element-122" data-mp="2t7dxgnx95y0x">
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block" data-id="element-123" data-mp="2y67888l5naxe">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-124" data-mp="xw0aostue36e" />
          </a>
          <div className="p-3" data-id="element-125" data-mp="ox52xcb5gl0z">
            <p className="text-sm font-black uppercase leading-tight text-forge" data-id="element-126" data-mp="oxyb8hprbil8">
              {PRODUCT_NAME}
            </p>
            <p className="mt-0.5 font-anton text-2xl uppercase tracking-wide" data-id="element-127" data-mp="1gn9v3x55iccr">
              6 Tomos + 5 Bonos
            </p>
            <p className="text-xs text-steel sm:text-sm" data-id="element-128" data-mp="1ckwqxd61ymi3">
              🎁 Bonos valorados en{' '}
              <span className="font-bold text-forge line-through" data-id="element-129" data-mp="17nefng4kbv6x">
                {BONUS_VALUE}
              </span>
            </p>

            <p className="mt-1.5 inline-block rounded bg-gold px-2.5 py-0.5 text-xs font-black uppercase tracking-wide text-ink" data-id="element-130" data-mp="17ubwmjlq501">
              🔥 Oferta especial
            </p>

            <p className="mt-1 font-anton text-5xl leading-none tracking-tight text-forge sm:text-6xl" data-id="element-131" data-mp="3tvawoazb9qgd">
              <span className="text-3xl text-ink sm:text-4xl" data-id="element-132" data-mp="2mdf3ppfmzuo">Hoy:</span>{' '}
              {PRICE}
            </p>
            <p className="mt-1 text-xs font-semibold text-steel" data-id="element-133" data-mp="3kt1nppjoy553">
              Pago único • Sin mensualidades • Acceso Digital
            </p>

            <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3" data-id="element-134" data-mp="3b2zxar3v8an0">
              🚀 Sí, quiero el sistema completo por {PRICE}
            </CtaButton>

            <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-semibold text-steel" data-id="element-135" data-mp="3fwb813bstbk7">
              <span className="flex items-center gap-1" data-id="element-136" data-mp="3645fnshmws4h">
                <ZapIcon size={12} className="text-forge" data-id="element-137" data-mp="364olwbxx9s2o" />
                Acceso Inmediato
              </span>
              <span className="text-steel/50" data-id="element-138" data-mp="2s6qk060sfo42">•</span>
              <span className="flex items-center gap-1" data-id="element-139" data-mp="2x2p43hf32jyo">
                <ShieldCheckIcon size={12} className="text-forge" data-id="element-140" data-mp="2dhxcba1ltprl" />
                Garantía de 7 Días
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}